<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3">
      <search-form :fields="search" />
      <el-tooltip class="item" effect="dark" content="绑定微信，可接收各类审核待办事项通知" placement="right-start">
        <el-button @click="createDialog = true">绑定微信</el-button>
      </el-tooltip>
    </el-button-group>

    <el-table :data="wechatNotifyBinds" resource="wechat-notify-binds">
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="nick_name" label="昵称" width="150" />

      <el-table-column label="头像" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.head_img">
            <el-image :src="scope.row.head_img" :preview-src-list="[scope.row.head_img]">
              <div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
            </el-image>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="notify_types" label="通知类型">
        <template slot-scope="scope">
          <el-tag size="medium" type="info" v-for="(val, index) in scope.row.decode_types" :key="index">{{ val }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" width="150" />
      <el-table-column prop="status" label="状态" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === true ? 'success' : 'warning'" disable-transitions>{{ scope.row.status_text }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updated_at" label="修改时间" width="170" />
      <el-table-column label="操作" width="150">
        <template #default="{ row, $index }">
          <el-button-group>
            <row-to-edit />
            <row-destroy />
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>

    <div style="text-align:center">
      <el-dialog title="扫码绑定" :visible.sync="createDialog" width="400px" center append-to-body :close="closeWxBind">
        <el-image :src="src">
          <div slot="placeholder" class="image-slot">加载中<span class="dot">...</span></div>
        </el-image>
      </el-dialog>
    </div>

  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm'
import Pagination from '@c/Pagination'
import { getWechatNotifyBinds, getAuthorizeUrl } from '@/api/wechat-notify-binds'
import RowDestroy from '@c/LzTable/RowDestroy'
import RowToEdit from '@c/LzTable/RowToEdit'

export default {
  name: 'Index',
  components: {
    RowToEdit,
    RowDestroy,
    SearchForm,
    Pagination,
  },
  data() {
    return {
      search: [
        {
          field: 'id',
          label: 'ID',
        },
        {
          field: 'nick_name',
          label: '昵称',
        },
      ],
      wechatNotifyBinds: [],
      page: null,

      createDialog: false,
      // - 扫码绑定 生成Url二维码
      src: '',
    }
  },
    created() {
        this.getAuthorizeUrl()
    },
  methods: {
      async getAuthorizeUrl() {
          const { data } = await getAuthorizeUrl()
          this.src = data
      },
      closeWxBind() {
          console.log('closeWxBind');
          location.reload()
      }
  },
  watch: {
    $route: {
      async handler(newVal) {
        const {
          data: { data, meta },
        } = await getWechatNotifyBinds(newVal.query)
        this.wechatNotifyBinds = data
        this.page = meta
      },
      immediate: true,
    },
    createDialog(newVal) {
      if (!newVal) {
      }
    },
  },
}
</script>
